import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {InactiveUserPasswordResetModalProps} from "@Modals/inactive-user-password-reset-modal/inactive-user-password-reset-modal.types";

export const openInactiveUserPasswordResetModal = (props: InactiveUserPasswordResetModalProps): void => {
  window.PMW.redux.store.dispatch(
      openPanelInModal({
        modalId: MODALS_IDS.INACTIVE_USER_PASSWORD_RESET_MODAL,
        panelProps: props,
      })
  );
};
